
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiIecChartDispSet as ObiIecChartDispSetElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-iec-chart-disp-set.js';
 
 
 

 
 export const ObiIecChartDispSet = createComponent({
   react: React,
   tagName: 'obi-iec-chart-disp-set',
   elementClass: ObiIecChartDispSetElement,
   events: {
     
   }
  });
 
 